export default "__VITE_ASSET__BiV4Duor__"